import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'platform-integrations-api.vendasta-local.com',
  'test': '',
  'demo': 'platform-integrations-demo.apigateway.co',
  'prod': 'platform-integrations-prod.apigateway.co',
  'production': 'platform-integrations-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ConnectionMethods = /*#__PURE__*/function (ConnectionMethods) {
  ConnectionMethods[ConnectionMethods["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  ConnectionMethods[ConnectionMethods["OAUTH2"] = 1] = "OAUTH2";
  ConnectionMethods[ConnectionMethods["APIKEY"] = 2] = "APIKEY";
  ConnectionMethods[ConnectionMethods["VENDOR_MANAGED"] = 3] = "VENDOR_MANAGED";
  return ConnectionMethods;
}(ConnectionMethods || {});
var ConnectionStatus = /*#__PURE__*/function (ConnectionStatus) {
  ConnectionStatus[ConnectionStatus["UNSPECIFIED_STATUS"] = 0] = "UNSPECIFIED_STATUS";
  ConnectionStatus[ConnectionStatus["PRECONNECTED"] = 1] = "PRECONNECTED";
  ConnectionStatus[ConnectionStatus["CONNECTED"] = 2] = "CONNECTED";
  ConnectionStatus[ConnectionStatus["DISCONNECTED"] = 3] = "DISCONNECTED";
  ConnectionStatus[ConnectionStatus["DELETED"] = 4] = "DELETED";
  return ConnectionStatus;
}(ConnectionStatus || {});
var SupportedContexts = /*#__PURE__*/function (SupportedContexts) {
  SupportedContexts[SupportedContexts["PI_CONTEXT_UNSET"] = 0] = "PI_CONTEXT_UNSET";
  SupportedContexts[SupportedContexts["PI_CONTEXT_PARTNER"] = 1] = "PI_CONTEXT_PARTNER";
  SupportedContexts[SupportedContexts["PI_CONTEXT_SMB"] = 2] = "PI_CONTEXT_SMB";
  return SupportedContexts;
}(SupportedContexts || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AdditionalInfo {
  static fromProto(proto) {
    let m = new AdditionalInfo();
    m = Object.assign(m, proto);
    if (proto.websites) {
      m.websites = proto.websites.map(WebsiteInfo.fromProto);
    }
    if (proto.resources) {
      m.resources = proto.resources.map(ResourceInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    if (typeof this.websites !== 'undefined' && this.websites !== null) {
      toReturn['websites'] = 'toApiJson' in this.websites ? this.websites.toApiJson() : this.websites;
    }
    if (typeof this.requirements !== 'undefined') {
      toReturn['requirements'] = this.requirements;
    }
    if (typeof this.resources !== 'undefined' && this.resources !== null) {
      toReturn['resources'] = 'toApiJson' in this.resources ? this.resources.toApiJson() : this.resources;
    }
    if (typeof this.businesses !== 'undefined') {
      toReturn['businesses'] = this.businesses;
    }
    if (typeof this.billing !== 'undefined') {
      toReturn['billing'] = this.billing;
    }
    return toReturn;
  }
}
class ConnectionResponse {
  static fromProto(proto) {
    let m = new ConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.status) {
      m.status = enumStringToValue$1(ConnectionStatus, proto.status);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    return toReturn;
  }
}
class CreateConnectionRequest {
  static fromProto(proto) {
    let m = new CreateConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    if (proto.context) {
      m.context = enumStringToValue$1(SupportedContexts, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    return toReturn;
  }
}
class CreateConnectionResponse {
  static fromProto(proto) {
    let m = new CreateConnectionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    return toReturn;
  }
}
class CreateIntegrationRequest {
  static fromProto(proto) {
    let m = new CreateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$1(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$1(SupportedContexts, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.authenticationUrl !== 'undefined') {
      toReturn['authenticationUrl'] = this.authenticationUrl;
    }
    if (typeof this.tokenUrl !== 'undefined') {
      toReturn['tokenUrl'] = this.tokenUrl;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.webhookVerifierToken !== 'undefined') {
      toReturn['webhookVerifierToken'] = this.webhookVerifierToken;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    return toReturn;
  }
}
class CreateIntegrationResponse {
  static fromProto(proto) {
    let m = new CreateIntegrationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class CustomFields {
  static fromProto(proto) {
    let m = new CustomFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DeleteConnectionRequest {
  static fromProto(proto) {
    let m = new DeleteConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class DeleteIntegrationRequest {
  static fromProto(proto) {
    let m = new DeleteIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class EmitEventRequest {
  static fromProto(proto) {
    let m = new EmitEventRequest();
    m = Object.assign(m, proto);
    if (proto.emittedAt) {
      m.emittedAt = new Date(proto.emittedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.payload !== 'undefined') {
      toReturn['payload'] = this.payload;
    }
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    if (typeof this.emittedAt !== 'undefined' && this.emittedAt !== null) {
      toReturn['emittedAt'] = 'toApiJson' in this.emittedAt ? this.emittedAt.toApiJson() : this.emittedAt;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    return toReturn;
  }
}
class EmitEventResponse {
  static fromProto(proto) {
    let m = new EmitEventResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    return toReturn;
  }
}
class GetConnectionRequest {
  static fromProto(proto) {
    let m = new GetConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetConnectionResponse {
  static fromProto(proto) {
    let m = new GetConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.status) {
      m.status = enumStringToValue$1(ConnectionStatus, proto.status);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    if (proto.context) {
      m.context = enumStringToValue$1(SupportedContexts, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    return toReturn;
  }
}
class GetIntegrationMarketingRequest {
  static fromProto(proto) {
    let m = new GetIntegrationMarketingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class GetIntegrationRequest {
  static fromProto(proto) {
    let m = new GetIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class GetIntegrationResponse {
  static fromProto(proto) {
    let m = new GetIntegrationResponse();
    m = Object.assign(m, proto);
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$1(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$1(SupportedContexts, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.authenticationUrl !== 'undefined') {
      toReturn['authenticationUrl'] = this.authenticationUrl;
    }
    if (typeof this.tokenUrl !== 'undefined') {
      toReturn['tokenUrl'] = this.tokenUrl;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.webhookVerifierToken !== 'undefined') {
      toReturn['webhookVerifierToken'] = this.webhookVerifierToken;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    return toReturn;
  }
}
class GetMultiIntegrationMarketingRequest {
  static fromProto(proto) {
    let m = new GetMultiIntegrationMarketingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationIds !== 'undefined') {
      toReturn['integrationIds'] = this.integrationIds;
    }
    return toReturn;
  }
}
class GetMultiIntegrationMarketingResponse {
  static fromProto(proto) {
    let m = new GetMultiIntegrationMarketingResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(IntegrationMarketingResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    return toReturn;
  }
}
class IntegrationMarketingResponse {
  static fromProto(proto) {
    let m = new IntegrationMarketingResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$1(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$1(SupportedContexts, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    return toReturn;
  }
}
class IntegrationsFilters {
  static fromProto(proto) {
    let m = new IntegrationsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    return toReturn;
  }
}
class ListConnectionRequest {
  static fromProto(proto) {
    let m = new ListConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListConnectionResponse {
  static fromProto(proto) {
    let m = new ListConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = proto.connections.map(ConnectionResponse.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListIntegrationMarketingRequest {
  static fromProto(proto) {
    let m = new ListIntegrationMarketingRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = IntegrationsFilters.fromProto(proto.filters);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = enumStringToValue$1(SupportedContexts, proto.supportedContexts);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    return toReturn;
  }
}
class ListIntegrationMarketingResponse {
  static fromProto(proto) {
    let m = new ListIntegrationMarketingResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(IntegrationMarketingResponse.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListIntegrationRequest {
  static fromProto(proto) {
    let m = new ListIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = IntegrationsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListIntegrationResponse {
  static fromProto(proto) {
    let m = new ListIntegrationResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(GetIntegrationResponse.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ResourceInfo {
  static fromProto(proto) {
    let m = new ResourceInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceName !== 'undefined') {
      toReturn['resourceName'] = this.resourceName;
    }
    if (typeof this.resourceUrl !== 'undefined') {
      toReturn['resourceUrl'] = this.resourceUrl;
    }
    return toReturn;
  }
}
class UpdateConnectionRequest {
  static fromProto(proto) {
    let m = new UpdateConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.updateFields) {
      m.updateFields = UpdateConnectionRequestUpdateFields.fromProto(proto.updateFields);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.updateFields !== 'undefined' && this.updateFields !== null) {
      toReturn['updateFields'] = 'toApiJson' in this.updateFields ? this.updateFields.toApiJson() : this.updateFields;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateIntegrationRequestUpdateFields {
  static fromProto(proto) {
    let m = new UpdateIntegrationRequestUpdateFields();
    m = Object.assign(m, proto);
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$1(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$1(SupportedContexts, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.authenticationUrl !== 'undefined') {
      toReturn['authenticationUrl'] = this.authenticationUrl;
    }
    if (typeof this.tokenUrl !== 'undefined') {
      toReturn['tokenUrl'] = this.tokenUrl;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.webhookVerifierToken !== 'undefined') {
      toReturn['webhookVerifierToken'] = this.webhookVerifierToken;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    return toReturn;
  }
}
class UpdateConnectionRequestUpdateFields {
  static fromProto(proto) {
    let m = new UpdateConnectionRequestUpdateFields();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$1(ConnectionStatus, proto.status);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    return toReturn;
  }
}
class UpdateIntegrationRequest {
  static fromProto(proto) {
    let m = new UpdateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.updateFields) {
      m.updateFields = UpdateIntegrationRequestUpdateFields.fromProto(proto.updateFields);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.updateFields !== 'undefined' && this.updateFields !== null) {
      toReturn['updateFields'] = 'toApiJson' in this.updateFields ? this.updateFields.toApiJson() : this.updateFields;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class WebsiteInfo {
  static fromProto(proto) {
    let m = new WebsiteInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.siteName !== 'undefined') {
      toReturn['siteName'] = this.siteName;
    }
    if (typeof this.siteUrl !== 'undefined') {
      toReturn['siteUrl'] = this.siteUrl;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetAuthorizationCodeRedirectURLRequest {
  static fromProto(proto) {
    let m = new GetAuthorizationCodeRedirectURLRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    return toReturn;
  }
}
class GetAuthorizationCodeRedirectURLResponse {
  static fromProto(proto) {
    let m = new GetAuthorizationCodeRedirectURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class RevokeAccessTokenAndDeleteRequest {
  static fromProto(proto) {
    let m = new RevokeAccessTokenAndDeleteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConnectionsApiService = /*#__PURE__*/(() => {
  class ConnectionsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateConnectionResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectionResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListConnectionResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ConnectionsApiService.ɵfac = function ConnectionsApiService_Factory(t) {
    return new (t || ConnectionsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConnectionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConnectionsApiService,
    factory: ConnectionsApiService.ɵfac,
    providedIn: 'root'
  });
  return ConnectionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationManagementApiService = /*#__PURE__*/(() => {
  class IntegrationManagementApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateIntegrationResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListIntegrationResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetIntegrationResponse.fromProto(resp)));
    }
    emitEvent(r) {
      const request = r.toApiJson ? r : new EmitEventRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/EmitEvent", request.toApiJson(), this.apiOptions()).pipe(map(resp => EmitEventResponse.fromProto(resp)));
    }
  }
  IntegrationManagementApiService.ɵfac = function IntegrationManagementApiService_Factory(t) {
    return new (t || IntegrationManagementApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IntegrationManagementApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationManagementApiService,
    factory: IntegrationManagementApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationManagementApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationMarketingApiService = /*#__PURE__*/(() => {
  class IntegrationMarketingApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListIntegrationMarketingRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationMarketingService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListIntegrationMarketingResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetIntegrationMarketingRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationMarketingService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => IntegrationMarketingResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiIntegrationMarketingRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationMarketingService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiIntegrationMarketingResponse.fromProto(resp)));
    }
  }
  IntegrationMarketingApiService.ɵfac = function IntegrationMarketingApiService_Factory(t) {
    return new (t || IntegrationMarketingApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  IntegrationMarketingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationMarketingApiService,
    factory: IntegrationMarketingApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationMarketingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let OAuthApiService = /*#__PURE__*/(() => {
  class OAuthApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAuthorizationCodeRedirectUrl(r) {
      const request = r.toApiJson ? r : new GetAuthorizationCodeRedirectURLRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.OAuthService/GetAuthorizationCodeRedirectURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuthorizationCodeRedirectURLResponse.fromProto(resp)));
    }
    revokeAccessTokenAndDelete(r) {
      const request = r.toApiJson ? r : new RevokeAccessTokenAndDeleteRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.OAuthService/RevokeAccessTokenAndDelete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  OAuthApiService.ɵfac = function OAuthApiService_Factory(t) {
    return new (t || OAuthApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  OAuthApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OAuthApiService,
    factory: OAuthApiService.ɵfac,
    providedIn: 'root'
  });
  return OAuthApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AdditionalInfo, ConnectionMethods, ConnectionResponse, ConnectionStatus, ConnectionsApiService, CreateConnectionRequest, CreateConnectionResponse, CreateIntegrationRequest, CreateIntegrationResponse, CustomFields, DeleteConnectionRequest, DeleteIntegrationRequest, EmitEventRequest, EmitEventResponse, FieldMask, GetAuthorizationCodeRedirectURLRequest, GetAuthorizationCodeRedirectURLResponse, GetConnectionRequest, GetConnectionResponse, GetIntegrationMarketingRequest, GetIntegrationRequest, GetIntegrationResponse, GetMultiIntegrationMarketingRequest, GetMultiIntegrationMarketingResponse, HostService, IntegrationManagementApiService, IntegrationMarketingApiService, IntegrationMarketingResponse, IntegrationsFilters, ListConnectionRequest, ListConnectionResponse, ListIntegrationMarketingRequest, ListIntegrationMarketingResponse, ListIntegrationRequest, ListIntegrationResponse, OAuthApiService, PagedRequestOptions, PagedResponseMetadata, ResourceInfo, RevokeAccessTokenAndDeleteRequest, SupportedContexts, UpdateConnectionRequest, UpdateConnectionRequestUpdateFields, UpdateIntegrationRequest, UpdateIntegrationRequestUpdateFields, WebsiteInfo };
